module.exports = __webpack_public_path__ + "img/concernimage.f4ae6d10.png";